import { render, staticRenderFns } from "./HomeNewSkins.vue?vue&type=template&id=5c3cf63b&scoped=true&"
import script from "./HomeNewSkins.vue?vue&type=script&lang=ts&"
export * from "./HomeNewSkins.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNewSkins.vue?vue&type=style&index=0&id=5c3cf63b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3cf63b",
  null
  
)

export default component.exports